<!-- 网费 -->
<template>
  <div id="pay">
    <div>
      <!-- 头部地理位置和搜索框 -->
      <div class="head">
        <!-- 顶部NavBar 开始 -->
        <van-nav-bar
          :title="$t('personOrder.title')"
          :left-text="$t('main.return')"
          left-arrow
          style="background-color: rgba(255,255,255,0);"
          @click-left="onClickLeft"
        />
      </div>
    </div>
    <div class="outboxstyle">
      <div class="boxstyle">
        <div class="lastbattry">{{ $t('personOrder.paymentAmount') }}:<span style="color:red;font-size:26px">¥&nbsp;{{ fenToYuan(orderAmount) }}</span></div>
      </div>
      <img :src="imageL[0]" style="width: 87%;left: 6.5%;position: absolute;">
      <div class="boxstylemoney">
        <div class="lastbattry">{{ $t('orderDetail.paymentMethod') }}:</div>
        <div v-for="(item, index) in paywayList" v-show="item.have" :key="item.id">
          <div :class="[item.show?'group':'group2']" @click="choose(item, index)">
            <img :src="item.show==true?imageL[1] : imageL[2]" style="width:40px; position:absolute;right:0;top:-0;z-Index:2;">
            <img :src="item.payImg" style="width:50px;margin:5px 0px 0 10px">
            <p style="display: inline-block; position: absolute;">{{ item.payWay }}</p>
          </div>
        </div>
        <!-- 原来 -->
        <!-- <div v-for="(item, index) in paywayList" :key="index">
          <div :class="[item.show?'group':'group2']" @click="choose(item, index)">
            <img :src="item.show==true?imageL[1] : imageL[2]" style="width:40px; position:absolute;right:0;top:-0;z-Index:2;">
            <img :src="item.payImg" style="width:50px;margin:5px 0px 0 10px">
            <p style="display: inline-block; position: absolute;">{{ item.payWay }}</p>
          </div>
        </div> -->
      </div>
    </div>
    <div class="bottom">
      <van-button type="info" size="large" :loading="btnLoading" loading-text="加载中..." class="bottombutton" @click="goNext">{{ $t('orderDetail.toPay') }}</van-button>
    </div>
    <!-- 回到顶部按钮 -->
    <!-- <v-top /> -->
  </div>
</template>

<script>
import { Toast } from 'vant'
import { getPayCodeListByProId } from '@/api/waitingPay'
import { toPayOrderTrade } from '@/api/registration/projectForRegistration'
import { fenToYuan } from '@/utils/commonUtils'
// import { updateOrderPayType } from '@/api/orderTrade'
import { getOrderById } from '@/api/orderlist'
export default {
  name: 'Person',
  data() {
    return {
      btnLoading: false, // 按钮loading状态
      chooseType: '',
      ip: '',
      tradeChannel: '',
      payCodeList: [],
      amount: '',
      orderNo: '',
      orderAmount: '',
      productDesc: '',
      conheight: {
        height: '',
        width: '100%',
        overflow: 'auto',
        // background: "#EFF6FF"
        background: 'transparent'
      },
      imageL: [
        require('../../assets/newImages/line.png'),
        require('../../assets/newImages/right.png'),
        require('../../assets/newImages/rightbefore.png'),
        require('../../assets/newImages/alipay.png'),
        require('../../assets/newImages/wechatpay.png'),
        require('../../assets/newImages/unionpay.png')
      ],
      paywayList: [
        {
          id: 1,
          payImg: require('../../assets/newImages/alipay.png'),
          payWay: '支付宝支付',
          payType: '01',
          show: false,
          have: false
        },
        {
          id: 2,
          payImg: require('../../assets/newImages/wechatpay.png'),
          payWay: '微信支付',
          payType: '02',
          show: false,
          have: false
        },
        {
          id: 3,
          payImg: require('../../assets/newImages/icon_jccz.png'),
          payWay: '金财财政非税统缴',
          payType: '81',
          show: false,
          have: false
        },
        {
          id: 4,
          payImg: require('../../assets/newImages/icon_icbc.png'),
          payWay: '中国工商银行',
          payType: '26',
          show: false,
          have: false
        }
        // {
        //   payImg: require('../../assets/newImages/unionpay.png'),
        //   payWay: '银联支付',
        //   show: false
        // }
      ]
    }
  },
  watch: {
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'background: #F5F5F5')
  },
  created() {
  },
  mounted() {
    this.getOrderById()
  },
  // beforeRouteEnter(to, from, next) {
  //   if (to.name === 'person') {
  //     next()
  //   }
  //   if (from.name === null) {
  //     next('/paySuccess')
  //   }
  //   if (from.name !== 'commonPay' && from.name !== 'orderDetail') {
  //     console.log(to.name)
  //     this.$router.push({ path: '/paySuccess' })
  //   } else {
  //     next()
  //   }
  // },
  methods: {
    fenToYuan(val) {
      return fenToYuan(val)
    },
    choose(obj, index) {
      obj.show = !obj.show
      if (obj.show === true) {
        for (let i = 0; i < this.paywayList.length; i++) {
          if (this.paywayList[i] !== this.paywayList[index]) {
            this.paywayList[i].show = false
          }
        }
      }
      this.chooseType = obj.payType
    },
    getOrderById() {
      getOrderById(this.$route.query.orderId).then(response => {
        this.orderAmount = response.data.amount
        this.orderNo = response.data.orderNo
        this.productDesc = response.data.productDesc
        this.tradeChannel = response.data.tradeChannel
        this.init()
      })
    },
    init() {
      getPayCodeListByProId(this.$route.query.projectId).then(response => {
        console.log(this.tradeChannel)
        if (this.tradeChannel === null || this.tradeChannel === '') {
          this.payCodeList = response.data
        } else {
          for (var i = 0; i < response.data.length; i++) {
            if (this.tradeChannel === response.data[i].paymentCode) {
              console.log(response.data[i])
              this.payCodeList.push(response.data[i])
            }
          }
        }
        for (let i = 0; i < this.payCodeList.length; i++) {
          if (this.payCodeList[i].paymentCode === '01') {
            // 支付宝
            this.paywayList[0].have = true
          } else if (this.payCodeList[i].paymentCode === '02') {
            // 微信
            this.paywayList[1].have = true
          } else if (this.payCodeList[i].paymentCode === '81') {
            // 非税
            this.paywayList[2].have = true
          } else if (this.payCodeList[i].paymentCode === '26') {
            // 工行
            this.paywayList[3].have = true
          }
        }
      })
    },
    goNext() {
      this.btnLoading = true
      // 下行注释误删，这是声明returnCitySN方法没有定义但是有使用
      // eslint-disable-next-line no-undef
      this.ip = '58.18.138.156'
      // var order = this.$route.query.order
      var payType = this.chooseType
      if (payType === '') {
        this.btnLoading = false
        Toast.fail(this.$t('msg.selectMethod'))
        return false
      }
      var thirdPayVO = {}
      if (window.localStorage.getItem('enterSource') === 'wechat') {
        thirdPayVO.tradeType = 'JSAPI'
        thirdPayVO.publicType = '2' // 服务号
        //  获取openId 方法 未完善！！！！！！！！
        thirdPayVO.openId = ''
      } else {
        thirdPayVO.tradeType = 'WAP'
      }
      thirdPayVO.payType = payType
      thirdPayVO.orderNo = this.orderNo
      thirdPayVO.ip = this.ip
      thirdPayVO.schoolCode = this.$store.state.settings.schoolCode
      thirdPayVO.dataSource = this.$store.state.settings.dataSource
      // 非税手机端和PC端业务相同
      if (payType === '81') {
        thirdPayVO.tradeType = 'NATIVE'
      }
      if (payType === '26') {
        thirdPayVO.tradeType = 'CASHIER'
      }
      toPayOrderTrade(thirdPayVO).then(response => {
      // var amountStr = fenToYuan(response.data.amount)
      // var payTypeName = ''
        if (response.data.payType === '01') {
          // payTypeName = '支付宝'
          if (response.data.tradeType === 'WAP') {
            document.querySelector('body').innerHTML = response.data.sbHtml // 查找到当前页面的body，将后台返回的form替换掉他的内容
            document.forms[0].submit()
          }
        } else if (response.data.payType === '02') {
          if (response.data.tradeType === 'JSAPI') {
            this.callWxPay(response.data)
          } else {
            window.location = response.data.mwebUrl
            this.$router.push({ path: '/paySuccess' })
          }
          window.location = response.data.mwebUrl
          this.$router.push({ path: '/paySuccess' })
          // payTypeName = '微信'
        } else if (response.data.payType === '81') {
          // 内蒙古金财财政统缴
          window.location = response.data.urlCode
          // payTypeName = '微信'
        } else if (response.data.payType === '26') {
          // 工行
          document.querySelector('body').innerHTML = response.data.sbHtml // 查找到当前页面的body，将后台返回的form替换掉他的内容
          document.forms[0].submit()
        }
        // this.$router.push({ name: 'payQrcode', query: { amount: fenToYuan(this.orderAmount), payType: payTypeName, qrcodeUrl: response.data.urlCode, orderId: this.$route.query.orderId }})
      }).catch(() => {
        this.btnLoading = false
      })
    },
    // 调用微信JS api 支付
    jsApiCall(data) {
      window.WeixinJSBridge.invoke('getBrandWCPayRequest', {
        'appId': data.appid,
        'timeStamp': data.timestamp,
        'nonceStr': data.noncestr,
        'package': data.wxpackage,
        'signType': 'MD5',
        'paySign': data.sign
      },
      function(res) {
        window.WeixinJSBridge.log(res.err_msg)
        if (res.err_msg === 'get_brand_wcpay_request:ok') {
          this.$router.push({ path: '/home' })
        } else {
          // 显示错误信息
          this.$toasted.show(res.err_code + res.err_desc + res.err_msg, {
            position: 'top-center',
            duration: 3000
          })
        }
        this.$router.push({ path: '/home' })
      })
    },
    callWxPay(params) {
      if (typeof window.WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', this.jsApiCall(params), false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', this.jsApiCall(params))
          document.attachEvent('onWeixinJSBridgeReady', this.jsApiCall(params))
        }
      } else {
        this.jsApiCall(params)
      }
    },
    // 返回
    onClickLeft() {
      // this.$router.go(-1)
      this.$router.push({
        path: '/home'
      })
    },
    // 带参数跳转页面
    dealwith(item) {
      this.$router.push({
        path: '/person'
      })
    }
  }
}
</script>
<style scoped lang="scss">
#pay {
  position: relative;
  background-color: #eff6ff;
  .head {
    height: 86px;
    width: 100%;
    background:linear-gradient(135deg, #3793e5 0%, #4046a6 100%);
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
}
.outboxstyle {
  padding: 10px;
  background-color: #F5F5F5;
  border-radius: 10px;
  margin-top: -20px;
  margin-bottom: 80px;
  width: 100%;
  height: 100%;
}
.boxstyle {
  margin: 10px 15px 0 15px;
  padding:20px 0;
  background-color: #ffffff;
  border: 1px white solid;
  border-radius: 10px 10px 0 0;
  box-shadow: 0px 4px 10px #dde9f3;
  p{
    font-size:16px;
    font-weight:700;
    margin: 20px;
  }
}
.boxstylemoney{
  margin: 10px 15px 15px;
  padding:20px 0;
  background-color: #ffffff;
  border: 1px white solid;
  border-radius: 10px;
  box-shadow: 0px 4px 10px #dde9f3;
  div{
    font-size:16px;
    margin: 20px 10px 10px 20px;
    color:#666;
    span{
      // float:right;
      color:#333;
    }
  }
  p{
    font-size:16px;
    font-weight:700;
    margin: 20px 20px 10px 20px;
  }
}
.lastbattry{
  border-left: 4px #1989fa solid;
  padding-left: 10px;
  margin: 20px;
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  span{
    color: #1989fa;
    float: right;
  }
}
.paymonry{
  border-left: 4px #1989fa solid;
  padding-left: 10px;
  margin: 20px;
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  span{
    color: red;
    float: right;
  }
}
.picker{
  border: 1px solid #eee;
  border-radius: 5px;
  margin: 10px 20px;
  width: 90%;
  padding: 5px;
}
.buttontext{
  width:90px;
  border-radius:5px
}
.bottom{
  width: 100%;
  background: #ffffff;
  position: fixed;
  bottom: 0;
  height: 80px;
}
.bottombutton{
  margin: 20px;
  width:90%;
  height: 40px;
}
.group {
  height:60px;
  border:1px solid #3BA4F2;
  border-radius:10px;
  position: relative;
}
.group2 {
  height:60px;
  border:1px solid #eee;
  border-radius:10px;
  position: relative;
}
</style>
<style>
.van-nav-bar .van-icon {
    color: #ffffff;
}
.van-nav-bar__title {
    color: #ffffff;
}
.van-nav-bar__text {
    color: #ffffff;
}
[class*='van-hairline']::after {
    border: none;
}
/* .van-cell {
    border: 1px solid #eee;
    border-radius: 5px;
    margin: 10px 20px;
    width: 90%;
} */
/* .van-field__control {
    height: 15px;
} */
.van-nav-bar {
  height: 80px;
}
</style>
